import { Skeleton } from 'antd';
import { memo, useEffect, useRef, useState } from 'react';
// import { useSelector } from 'react-redux';
import LargeFooterTop from './Large-footer-top/LargeFooterTop';
import LargeFooterBottom from './Large-footer-bottom/LargeFooterBottom';
import './style.scss';
import { useGetFooterImageQuery } from '../../Admin/Footer-Image/store/footerImageSlice';

// import { commonState } from '../../../app/base/commonSlice';

function LargeFooter() {
  // const isExtraLargeScreen = useMediaQuery({ minWidth: 2560 });
  // const { footerApiCall } = useSelector(commonState);
  const [shouldFetch, setShouldFetch] = useState(false);
  const footerRef = useRef(null); // Reference to the footer element

  useEffect(() => {
    // Function to check if the footer is already visible
    const checkIfFooterIsVisible = () => {
      if (!footerRef.current) return false;
      // @ts-ignore
      const rect = footerRef.current.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom >= 0;
    };

    setTimeout(() => {
      if (checkIfFooterIsVisible()) {
        setShouldFetch(true);
      }
    }, 100);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldFetch(true);
        }
      },
      { threshold: 0.1 }
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    return () => {
      if (footerRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(footerRef.current);
      }
    };
  }, []);
  const { data: footerImageData, isLoading } = useGetFooterImageQuery(
    undefined,
    {
      skip: !shouldFetch,
    }
  );

  return (
    <div
      ref={footerRef}
      className="large-footer bg-[#0D252E] w-full dark:bg-[#1d1d1d] text-white dark:text-white"
    >
      <div className="hidden md:block">
        {isLoading ? (
          <Skeleton />
        ) : (
          <img
            className="footer-image pt-20 w-full"
            src={footerImageData?.image}
            alt="footer_image"
          />
        )}
      </div>
      <LargeFooterTop />
      <div className="md:pl-[120px] pl-[10px] md:pr-[140px] pr-[10px]">
        <div className="border border-slate-700" />
      </div>

      <LargeFooterBottom />
    </div>
  );
}

export default memo(LargeFooter);
